<template>
  <div id="app">
    <keep-alive include="Layout,HomePage,ServiceList">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '@/styles/index.scss';
</style>

